import { Component, OnInit } from '@angular/core';
import { BookingStudentService } from '../service/booking-student.service';
import { BookingService } from '../service/booking.service';
import { FormArray } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-booking-student',
  templateUrl: './booking-student.component.html',
  styleUrls: ['./booking-student.component.css']
})
export class BookingStudentComponent implements OnInit {

  yearRange: string = "1980:2024";

  constructor(
    public bookingService: BookingService,
    public bookingStudentService: BookingStudentService
  ) {
    for(let comment of bookingService.booking.student.studentComments!){
      comment.created = moment(comment.created);
    }
   }

  ngOnInit(): void {
  }

  get studentContactFormArray(){
    let formArray = this.bookingStudentService.studentForm.get('contacts') as FormArray;
    return formArray.controls;
  }

}
